module.exports = [{
  plugin: require('/Users/NickLoeper/fisherman/fisherman-website-generator/output/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}, {
  plugin: require('/Users/NickLoeper/fisherman/fisherman-website-generator/output/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
  options: {
    "plugins": [],
    "trackingId": "UA-125789165-45",
    "head": true
  }
}];